import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const MusicVideoPage = () => (
  <Layout>
    <SEO title="video" />
    <h1>Music Video</h1>
    <p>This site is under contstruction.</p>
  </Layout>
)

export default MusicVideoPage
